export default __webpack_public_path__ + "static/media/etiquetaProducto.1c6aa4fb.svg";